import { renderDrawerBody_unstable } from '@fluentui/react-drawer';

/**
 * Renders the final JSX of the DrawerBody component, given the state.
 */
export const renderDrawerBody = renderDrawerBody_unstable;
